import { Reveal, SectionLabel } from "../Reveal";
import { TAKEAWAYS } from "../../content";

export const Takeaways = () => (
  <section className="py-28 md:py-36 px-6 sm:px-10 lg:px-16 xl:px-24 bg-white/[0.015]" data-testid="takeaways-section">
    <Reveal><SectionLabel num="007" text="THE OUTCOME" /></Reveal>
    <Reveal delay={0.05}>
      <h2 className="serif font-black uppercase tracking-tight text-3xl md:text-5xl text-white mb-14">
        WHAT YOU&apos;LL <span className="text-[#FE0000]">WALK AWAY WITH</span>
      </h2>
    </Reveal>
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {TAKEAWAYS.map((t, i) => (
        <Reveal key={i} delay={i * 0.07}>
          <div
            className="h-full rounded-lg border border-white/10 bg-white/[0.02] p-7 hover:border-[#FE0000]/60 hover:-translate-y-1 transition-[border-color,transform] duration-300"
            data-testid={`takeaway-card-${i}`}
          >
            <div className="text-3xl mb-5">{t.emoji}</div>
            <h3 className="serif font-black uppercase text-lg text-white mb-3">{t.title}</h3>
            <p className="text-sm text-white leading-relaxed">{t.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
